<template>
  <div class="space-logo" :style="{'--diameter': diameter}">
    <img v-if="logo" @load="setImageSize" class="space-logo__image" :src="image" />
    <div v-else class="space-logo__initials">{{ initials }}</div>
  </div>
</template>
<script>
import { mapToRangeClamped, initaliseAreaName, processMediaURL } from '@/functions/utility.js';

export default {
  name: 'SpaceLogo',
  props: {
    logo: String,
    title: String,
    diameter: {
        type: String,
        default: '120px'
    }
  },
  computed: {
    initials: function () {
      return initaliseAreaName(this.title);
    },
    image: function () {
      return processMediaURL(this.logo);
    }
  },
  methods: {
    setImageSize(e) {
      // this code exists because setting 70% width makes wide, short logos (most logos) look good
      // but the corners of square logos (like MCCGLC's) go to the edge of the circle (looks bad)
      // designs show the square logo at 50% size, to avoid this problem, but most logos don't look good at 50% width
      // therefore, the code needs to be able to change the width depending on the ratio of the width and height of the logo
      // of course, the same princples apply to tall logos (v unusual), so the else handles that edge case
      let image = e.target;
      let { naturalWidth: w, naturalHeight: h } = image;
      if (w > h) image.style.width = mapToRangeClamped(h / w, 1, 0.6, 50, 70) + '%';
      else image.style.height = mapToRangeClamped(w / h, 1, 0.6, 50, 70) + '%';
    }
  }
};
</script>
<style lang="scss" scoped>
.space-logo {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-around;

  width: var(--diameter);
  height: var(--diameter);
  background-color: white;
  border-radius: 100%;
  box-shadow: 0px 0px 6px #00000066;

  &__image {
    display: block;
    margin: auto;
  }
  &__initials {
    color: black;
    font-size: 29px;
    font-weight: bold;
  }
}
</style>